
export class Service{

    constructor(serviceShortName: string) {
        this.nameShort = serviceShortName;
        this.id = null;
    }

    id: number;
    nameShort: string;

}
